<div class="investor-block" [ngClass]="{'investor-block-full': full}">
  <div [ngSwitch]="investor.type" class="investor-icon" [ngClass]="{'investor-icon-full': full}">
    <ng-container *ngSwitchCase="InvestingEntityType.LLC">
      <mat-icon svgIcon="llc" />
    </ng-container>
    <ng-container *ngSwitchCase="InvestingEntityType.LLP">
      <mat-icon svgIcon="llp" />
    </ng-container>
    <ng-container *ngSwitchCase="InvestingEntityType.Personal">
      <mat-icon svgIcon="personal" />
    </ng-container>
    <ng-container *ngSwitchCase="InvestingEntityType.Trust">
      <mat-icon svgIcon="trust" />
    </ng-container>
    <ng-container *ngSwitchCase="InvestingEntityType.Inc">
      <mat-icon svgIcon="inc" />
    </ng-container>
    <ng-container *ngSwitchCase="InvestingEntityType.Ltd">
      <mat-icon svgIcon="ltd" />
    </ng-container>
    <ng-container *ngSwitchCase="InvestingEntityType.RetirementPlan">
      <mat-icon svgIcon="plan" />
    </ng-container>
    <ng-container *ngSwitchCase="InvestingEntityType.LP">
      <mat-icon svgIcon="lp" />
    </ng-container>
    <ng-container *ngSwitchDefault>
      <mat-icon>empty</mat-icon>
    </ng-container>
  </div>

  <div class="investor">
    <div class="investor-name">
      {{investor.name}}
    </div>
    <div class="investor-email" *ngIf="full">
      {{investor.email}}
    </div>
  </div>
</div>
